<div class="d-flex align-items-center">
    <button mat-flat-button class="custom-button-volver" (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Volver" fontIcon="arrow_back" class="icon-volver mr-3"></mat-icon>
        Volver
    </button>
</div>
<div class="container-fluid bg-white p-5 mb-5 br-10">
    <div class="col-12">
        <h1>Editar cartera</h1>
        <mat-chip-set aria-label="Rut principal">
            <mat-chip class="chip-rut">
                <strong>ID:</strong> {{ detail?.id }}
            </mat-chip>
        </mat-chip-set>
    </div>

    <mat-card class="form-container simple-card mx-auto my-5">
        <mat-card-content class="p-5">
            <div class="mb-5">
                <form [formGroup]="bagForm">
                    <mat-form-field appearance="outline" class="w-100 mb-4">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>

                    <div class="border p-5 d-flex justify-content-center flex-column align-items-center">
                        <input
                            #fileInput
                            hidden
                            class="input-file"
                            type="file"
                            name="file"
                            accept=".csv"
                            id="file-csv-carga-automatica"
                            (change)="handleUpload($event)"/>

                        <button
                            mat-flat-button
                            class="custom-button-secondary"
                            type="button"
                            [disabled]="formLoading"
                            (click)="fileInput.click()">
                            <mat-icon class="mr-3">upload</mat-icon>
                            Subir Archivo
                        </button>
                        <p class="hint-text">Archivo .csv, separado por ; y con máximo 100 registros</p>

                        <div *ngIf="fileName" class="border py-2 px-5 mb-3 d-flex align-items-center">
                            <mat-icon
                                aria-hidden="false"
                                aria-label="icono de csv"
                                class="text-secondary"
                                fontIcon="article">
                            </mat-icon>
                            <span>{{ fileName }}</span>
                        </div>

                        <a 
                            mat-button
                            color="primary"
                            id="descargaejemplo"
                            title="Descargar archivo"
                            href="../assets/files/ejemploCrearCartera.csv"
                            download>
                            <mat-icon>download</mat-icon>
                            Descargar archivo de ejemplo
                        </a>
                    </div>
                </form>
            </div>

            <div class="d-flex justify-content-end">
                <button mat-flat-button class="custom-button-primary" type="button" (click)="submitArchivo()" [disabled]="formLoading || isBagDataLoading">
                    <mat-icon *ngIf="formLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                    <mat-icon class="mr-3">save</mat-icon>
                    Guardar cambios
                </button>
            </div>

        </mat-card-content>
    </mat-card>

</div>